var Event = require('./feedAction/event');
var Survey = require('./feedAction/survey');

function FeedAction(app, userId){
	var self = this;
	self.app = app;
	self.userId = userId;
}

FeedAction.prototype.event = function(){
	var self = this;
	return new Event(self.app, self.userId);
}

FeedAction.prototype.survey = function(){
	var self = this;
	return new Survey(self.app, self.userId);
}

module.exports = FeedAction;